import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Legend,
  Tooltip,
} from "chart.js";
import { Chart } from "react-chartjs-2";

import OverviewMetricsChart from "./OverviewMetricsChart";
import {
  buildWorkerHoursChartData,
  getWorkerHoursChartOptions,
} from "./chartsHelpers";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Legend,
  Tooltip
);

/**
 * Worker Hours overview chart: stacked RT/OT/DT bars + workers line.
 * Defaults to Weekly for Range All (≥ 8 weeks), else Daily; user can toggle.
 *
 * @param {Object} props
 * @param {Array<Object>} [props.days] - Aggregated day rows from worker-hours metrics.
 * @param {{key?: string, start: string|null, end: string|null}|null} [props.range] - Active Range filter.
 * @param {string} [props.typeLabel="All"] - Active Type name for legend/tooltips.
 * @param {boolean} [props.isLoading] - Whether source metrics are still loading.
 * @returns {JSX.Element}
 */
const WorkerHoursChart = ({
  days = [],
  range = null,
  typeLabel = "All",
  isLoading = false,
}) => (
  <OverviewMetricsChart
    days={days}
    range={range}
    typeLabel={typeLabel}
    isLoading={isLoading}
    emptyMessage="No hours in this range"
    buildChartData={buildWorkerHoursChartData}
    getChartOptions={getWorkerHoursChartOptions}
    renderChart={(data, options) => (
      <Chart type="bar" data={data} options={options} />
    )}
  />
);

export default WorkerHoursChart;
